module.exports = "https://cdn-b2c.dom.ru/b2c-domru/2.357.4/frontend/_next/static/images/picture_4-5f2d8d3c4edd918e62f0904229ee87f0.png";